
import { createSlice } from '@reduxjs/toolkit';

const colorSlice = createSlice({
    name: 'colorPallet',
    initialState: {
        colorType:null,
        SVGColor:null,
        shadowColor: '#000',
        outlineColor: '#000',
        activeGradientCol:'#000',
        triggerColorPallet:0,
    },
    reducers: {
        setShadowColour: (state, action) => {
            state.shadowColor = action.payload;
        },
        setOutlineColour: (state, action) => {
            state.outlineColor = action.payload;
        },
        setColorType: (state, action) => {
            state.colorType = action.payload;
        },
        setSVGColorObject: (state, action) => {
            state.SVGColor = action.payload;
        },
        setGradientCol: (state, action) => {
            state.activeGradientCol = action.payload;
        },
        toggleTriggerPallet:(state, action) => {
            state.trigerColorPallet = !state.trigerColorPallet;
        },
    },
});

export const { toggleTriggerPallet, setShadowColour, setOutlineColour, setColorType, setGradientCol, setSVGColorObject } = colorSlice.actions;
export default colorSlice.reducer;
